module.exports = __webpack_public_path__ + "static/media/box-number-silver.0a301778.png";